import FormFieldTextArea from '@/components/FormFieldTextArea';
const ClientNotes = () => {
  return (
    <div className="flex flex-col gap-6 mt-10">
      <FormFieldTextArea
        name="instructions"
        label="Client’s Instructions"
        placeholder="Enter Client’s Instructions"
        rows={5}
      />
    </div>
  );
};

export default ClientNotes;
